import Whole from './Whole.vue';
export default Whole;
